import React, { Component } from "react";
import { PostData } from "../../../../service/postData";
import { sendNotification } from "../../../../_notificationSettings/notificationPanel";
import { MDBDataTableV5 } from "mdbreact";
import { numberFormat } from "../../../../config/numberFormat";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { Link } from 'react-router-dom';
import * as XLSX from "xlsx";
import * as FileSaver from 'file-saver'; 

import moment from "moment";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";


let _UserSession = localStorage.getItem("vs_UserSession");
let _signingId = "0";
let _businessId = "0";
let _companyId = "0";

if (_UserSession!=undefined || _UserSession!=null) {
  _UserSession = JSON.parse(_UserSession);
  _signingId = _UserSession.loginId;
  _businessId = _UserSession.tokenKey;
}

let _companySession = localStorage.getItem("vs_UserCompanySession");
if (_companySession!=undefined || _companySession!=null) {
  _companySession = JSON.parse(_companySession);
  _businessId = _companySession.business_id;
  _companyId = _companySession.company_id;
}

let columns = [
  {
    label: "#",
    field: "sr_no",
    width: 100,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "#",
    },
  },
  {
    label: "Item Name",
    field: "item_name",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Item Name",
    },
  },
  {
    label: "Sale Amount",
    field: "sale_amount",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Sale Amount",
    },
  },
  {
    label: "Purchase Amount",
    field: "purchase_amount",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Purchase Amount",
    },
  },
  {
    label: "Stock Qty",
    field: "stock_qty",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Stock Qty",
    },
  },
  {
    label: "Stock Value",
    field: "stock_value",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Stock Value",
    },
  },
];

let _loader = "glb-ldr-prt active";
let _currentYear = moment().format("YYYY");
let _startDateYaer = "01/01/" + _currentYear;
let _endDateYaer = "12/31/" + _currentYear;
export default class dayBookReportPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: true,
      transactionArray: [],
      transactionArrayFilter: [],
      activeTransactionKey: "ALL",
      businessId: _businessId,
      company_id: _companyId,
      userId: _signingId,
      name: null,
      startDate : moment().startOf('month').format('YYYY-MM-DD'),
      endDate : moment().endOf('month').format('YYYY-MM-DD'),
      dateLabel: "",
      categoryArray: [],
      selectedCategoryId: "0",
      selectedCategoryName: "All Categories",
      showCategoryDropdown: false,
      lowStockCount: 0,
      totalItems: 0,
      errors: {
        name: "",
      },
    };
  }

  async componentDidMount() {
    this.getCategoryList();
    this.getSaleListData(this.state.activeTransactionKey);
  }

  getCategoryList() {
    const requestData = JSON.stringify({
      businessId: this.state.businessId,
      company_id: this.state.company_id,
    });
    PostData(global.itemCategoryList, requestData, "POST")
      .then((result) => {
        let responseJson = result;
        if (responseJson.success && responseJson.response) {
          this.setState({ categoryArray: responseJson.response });
        }
      })
      .catch((error) => console.error("Category List Error: ", error));
  }

  handleCategoryFilter = (categoryId, categoryName) => {
    this.setState({
      selectedCategoryId: categoryId,
      selectedCategoryName: categoryName,
      showCategoryDropdown: false
    }, () => this.getSaleListData(this.state.activeTransactionKey));
  };

  toggleCategoryDropdown = () => {
    this.setState({ showCategoryDropdown: !this.state.showCategoryDropdown });
  };

  getSaleListData(_type) {
    let _transArray = [];
    let _totalSaleAmt = 0;
    let _totalPurchaseAmt = 0;
    let _totalStockQty = 0;
    let _totalStockValue = 0;

    const requestData = JSON.stringify({
        business_id: this.state.businessId,
        company_id: this.state.company_id,
        type: _type,
        isDateFilter: true,
        start_date: this.state.startDate,
        end_date: this.state.endDate,
        category_id: this.state.selectedCategoryId,
    });

    PostData(global.stockSummeryReport, requestData, "POST")
        .then((result) => {
            let responseJson = result;
            if (responseJson.success === false) {
                this.setState({
                    transactionArrayFilter: _transArray,
                    itemArray: _transArray,
                    isLoaded: true,
                    totalSaleAmt: _totalSaleAmt,
                    totalPurchaseAmt: _totalPurchaseAmt,
                    totalStockQty: _totalStockQty,
                    totalStockValue: _totalStockValue,
                });
            } else {
                let _lowStockCount = 0;
                if (responseJson.response) {
                    _transArray = responseJson.response;
                    _transArray.map((itm) => {
                        _totalSaleAmt += parseFloat(itm.total_sale_amount || 0);
                        _totalPurchaseAmt += parseFloat(itm.total_purchase_amount || 0);
                        _totalStockQty += parseFloat(itm.total_stock_quantity || 0);
                        _totalStockValue += parseFloat(itm.total_stock_value || 0);
                        // Count low stock items (stock qty <= min_stock or stock qty <= 0)
                        if (parseFloat(itm.total_stock_quantity || 0) <= parseFloat(itm.min_stock || 0) || parseFloat(itm.total_stock_quantity || 0) <= 0) {
                            _lowStockCount++;
                        }
                    });
                }
                this.setState({
                    transactionArrayFilter: _transArray,
                    itemArray: _transArray,
                    isLoaded: true,
                    totalSaleAmt: _totalSaleAmt,
                    totalPurchaseAmt: _totalPurchaseAmt,
                    totalStockQty: _totalStockQty,
                    totalStockValue: _totalStockValue,
                    lowStockCount: _lowStockCount,
                    totalItems: _transArray.length,
                });
            }
        })
        .catch((error) => this.setState({ error, isLoaded: false }));
  }

  loadTranscListing() {
      let dataList = [];
      let rows = [];
      
      if (this.state.isLoaded) {
          let _transDetails = this.state.transactionArrayFilter;
          if (_transDetails.length > 0) {
              _transDetails.map((value) => {
                  rows.push({
                      srNo: value.srNo,
                      item_name: value.item_name,
                      total_sale_amount: numberFormat(value.total_sale_amount || 0),
                      total_purchase_amount: numberFormat(value.total_purchase_amount || 0),
                      total_stock_quantity: numberFormat(value.total_stock_quantity || 0),
                      total_stock_value: numberFormat(value.total_stock_value || 0),
                  });
              });
          }
      }

      const columns = [
          { label: "Sr No", field: "srNo", sort: "asc" },
          { label: "Item Name", field: "item_name", sort: "asc" },
          { label: "Total Sale Amount", field: "total_sale_amount", sort: "asc" },
          { label: "Total Purchase Amount", field: "total_purchase_amount", sort: "asc" },
          { label: "Total Stock Quantity", field: "total_stock_quantity", sort: "asc" },
          { label: "Total Stock Value", field: "total_stock_value", sort: "asc" }
      ];

      if (rows.length > 0) {
          dataList = {
              columns: columns,
              rows: rows,
          };
      }
      
      return dataList;
  }


  handleCallBackDate = (start, end) => {
    this.setState({
      startDate: start.format("YYYY-MM-DD"),
      endDate: end.format("YYYY-MM-DD"),
    });
    this.getSaleListData();
  };

  exportData = (event) =>{
    let _itemDetails = this.state.itemArray;
    try {
      let totalAmount = 0;
      _itemDetails.map((data) => {
        totalAmount += parseFloat(data.total_amount);
      });

      _itemDetails = _itemDetails.map((data) => {

        let newData = {
          'srNo': data.srNo,
          'Item Name': data.item_name,
          'Total Sale Amount': data.total_sale_amount,
          'Total Purchase Amount': data.total_purchase_amount,
          'Total Stock Quantity': data.total_stock_quantity,
          'Total Stock Value': data.total_stock_value,
        }
          return newData;
      });


      _itemDetails.push({});
      var ws = XLSX.utils.json_to_sheet(_itemDetails);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb,ws,"Stock Summary Report");
      const wbout = XLSX.write(wb, {type:'array', bookType:"xlsx"});
      let length = 6;
      let uniqueNo = String(Math.floor(Math.pow(10, length - 1) + Math.random() * (Math.pow(10, length) - Math.pow(10, length - 1) - 1)));
      let fileName = 'export_stock_summary_'+moment().format('YYYY-MM-DD')+'.xlsx';
      const data = new Blob([wbout], {type: "xlsx"});
      FileSaver.saveAs(data, fileName);

    } catch (err) {
      //alert('Unknown Error: ' + JSON.stringify(err));
      throw err;
    }
  }

  clickToDelete(value, type) {
    confirmAlert({
      title: "Confirm to delete",
      message: "Are you sure you want to delete?",
      buttons: [
        {
          label: "Yes",
          className: "btn btn-danger",
          onClick: () => {
            const requestData = JSON.stringify({
              sale_id: value,
              type_value: type,
            });
            PostData(global.deleteSaleTransaction, requestData, "POST").then(
              (result) => {
                let responseJson = result;
                if (responseJson.success == false) {
                  sendNotification(
                    "Error Message 😓",
                    responseJson.message,
                    "danger"
                  );
                  return;
                } else {
                  sendNotification(
                    "Success Message 👍",
                    responseJson.message,
                    "success"
                  );
                  this.getSaleListData();
                  return;
                }
              }
            );
          },
        },
        {
          label: "No",
          className: "btn btn-primary",
        },
      ],
    });
  }

  render() {
    if (this.state.isLoaded == true) {
      _loader = "glb-ldr-prt";
    }
    const { errors } = this.state;
    return (
      <React.Fragment>
        <div className="content">
          <div className="block">
            <div className="row">
              <div className="col-md-12">
                <h5># Stock Summary</h5>
                <div className="block">
                  <div className="block-content" style={{ marginTop: "-20px" }}>
                    <div className="row items-push">
                      <div className="row col-lg-12">
                        <div className="col-lg-4">
                          <span>Date Filter : </span>
                          <DateRangePicker
                            initialSettings={{
                              startDate: this.state.startDate,
                              endDate: this.state.endDate,
                              locale: {
                                format: "YYYY-MM-DD",
                              },
                              ranges: {
                                Today: [moment().toDate(), moment().toDate()],
                                Yesterday: [
                                  moment().subtract(1, "days").toDate(),
                                  moment().subtract(1, "days").toDate(),
                                ],
                                "This Week": [
                                  moment()
                                    .startOf("week")
                                    .format("YYYY-MM-DD"),
                                  moment().endOf("week").format("YYYY-MM-DD"),
                                ],
                                "This Month": [
                                  moment().startOf("month").toDate(),
                                  moment().endOf("month").toDate(),
                                ],
                                "Last Month": [
                                  moment()
                                    .subtract(1, "month")
                                    .startOf("month")
                                    .toDate(),
                                  moment()
                                    .subtract(1, "month")
                                    .endOf("month")
                                    .toDate(),
                                ],
                                "This Quarter": [
                                  moment().startOf("month").toDate(),
                                  moment()
                                    .add(2, "month")
                                    .endOf("month")
                                    .toDate(),
                                ],
                                "This Financial Year": [
                                  moment()
                                    .month("April")
                                    .startOf("month")
                                    .format("YYYY-MM-DD"),
                                  moment()
                                    .add(1, "year")
                                    .month("March")
                                    .endOf("month")
                                    .format("YYYY-MM-DD"),
                                ],
                              },
                            }}
                            onCallback={this.handleCallBackDate}
                          >
                            <input
                              type="text"
                              className="form-control"
                              style={{ display: "inline-block" }}
                            />
                          </DateRangePicker>
                        </div>
                        <div className="col-lg-4">
                          <span>Category : </span>
                          <div className="custom-dropdown">
                            <div className="custom-dropdown-btn" onClick={this.toggleCategoryDropdown}>
                              <span>{this.state.selectedCategoryName}</span>
                              <span>▼</span>
                            </div>
                            {this.state.showCategoryDropdown && (
                              <div className="custom-dropdown-menu">
                                <div
                                  className={`custom-dropdown-item ${this.state.selectedCategoryId === "0" ? "selected" : ""}`}
                                  onClick={() => this.handleCategoryFilter("0", "All Categories")}
                                >
                                  All Categories
                                </div>
                                {this.state.categoryArray.map((category) => (
                                  <div
                                    key={category.id}
                                    className={`custom-dropdown-item ${this.state.selectedCategoryId === String(category.id) ? "selected" : ""}`}
                                    onClick={() => this.handleCategoryFilter(String(category.id), category.categoryName)}
                                  >
                                    {category.categoryName}
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="row pb-20 pull-right">
                            <div className="text-right">
                              <div className="js-appear-enabled text-center">
                                <Link onClick={this.exportData} >
                                  <div className="text-info">
                                    <i className="fa fa-file-excel-o"></i>
                                  </div>
                                  <div className="font-size-sm text-muted">
                                    Excel Export
                                  </div>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                        <br />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Summary Cards */}
          <div className="block" style={{ marginTop: "-40px" }}>
            <div className="row">
              <div className="col-md-3 col-sm-6">
                <div className="block block-rounded" style={{ backgroundColor: "#e3f2fd", padding: "15px", textAlign: "center" }}>
                  <div style={{ fontSize: "14px", color: "#666" }}>Total Items</div>
                  <div style={{ fontSize: "24px", fontWeight: "bold", color: "#1976d2" }}>{this.state.totalItems}</div>
                </div>
              </div>
              <div className="col-md-3 col-sm-6">
                <div className="block block-rounded" style={{ backgroundColor: "#fff3e0", padding: "15px", textAlign: "center" }}>
                  <div style={{ fontSize: "14px", color: "#666" }}>Low Stock Items</div>
                  <div style={{ fontSize: "24px", fontWeight: "bold", color: "#f57c00" }}>{this.state.lowStockCount}</div>
                </div>
              </div>
              <div className="col-md-3 col-sm-6">
                <div className="block block-rounded" style={{ backgroundColor: "#e8f5e9", padding: "15px", textAlign: "center" }}>
                  <div style={{ fontSize: "14px", color: "#666" }}>Total Stock Qty</div>
                  <div style={{ fontSize: "24px", fontWeight: "bold", color: "#388e3c" }}>{numberFormat(this.state.totalStockQty || 0)}</div>
                </div>
              </div>
              <div className="col-md-3 col-sm-6">
                <div className="block block-rounded" style={{ backgroundColor: "#fce4ec", padding: "15px", textAlign: "center" }}>
                  <div style={{ fontSize: "14px", color: "#666" }}>Total Stock Value</div>
                  <div style={{ fontSize: "24px", fontWeight: "bold", color: "#c2185b" }}>{numberFormat(this.state.totalStockValue || 0)}</div>
                </div>
              </div>
            </div>
          </div>

          <div className="block" style={{ marginTop: "-20px" }}>
            <div className="row">
              <div className="col-md-12">
                <div className="block">
                  <div className="block-content">
                    <h2 className="block-title ml-10">Stock Summary</h2>
                    {/* <a href={global.webUrl+"business/add-sale/"} style={{marginTop: '35px'}} className="pull-right pull-right btn btn-sm btn-primary mb-10">
                        <i className="fa fa-plus-circle"></i> Add Sale
                    </a> */}
                  </div>
                  <div className="block-content" id="tableData">
                    <MDBDataTableV5
                      hover
                      entriesOptions={[25, 50, 100, 500]}
                      entries={25}
                      pagesAmount={4}
                      span
                      //pagingTop
                      searchTop
                      searchBottom={false}
                      barReverse
                      data={this.loadTranscListing()}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="global_loader" className={_loader}>
          <div className="gl-ldr-cld">
            <div className="gl-ldr-ctr">
              <div className="gl-loader"></div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
